<div
  class="d-flex justify-content-between offer-breakdown-cell"
  [class]="backgroundClass"
>
  <div wlCSCapture>
    {{ description }}
  </div>
  <div wlCSCapture>{{ prefix }} {{ value | roundedCurrency }}</div>
</div>
